module.exports = __webpack_public_path__ + "static/media/Projects.29ad8838.png";